<template>
  <footer class="mini-footer">

    <!-- ============================= -->
    <!--         FOOTER CONTENT        -->
    <!-- ============================= -->
    <div class="footer-content">

      <!-- ============================= -->
      <!--        🌐 SOCIAL MEDIA        -->
      <!-- ============================= -->
      <div class="social-media">

        <span class="social-text">
          Мы в соцсетях
        </span>

        <div class="social-icons">

          <a
            href="https://t.me/hyperappstore"
            target="_blank"
            rel="noopener noreferrer"
            class="social-link"
            aria-label="Telegram"
          >
            <img
              src="/tg_icon.png"
              alt="Telegram"
              class="social-icon"
            />
          </a>

          <a
            href="https://instagram.com/hyper_app"
            target="_blank"
            rel="noopener noreferrer"
            class="social-link"
            aria-label="Instagram"
          >
            <img
              src="/ins_icon.png"
              alt="Instagram"
              class="social-icon"
            />
          </a>

        </div>
      </div>


      <!-- ============================= -->
      <!--        ⚖️ LEGAL LINKS         -->
      <!-- ============================= -->
      <div class="mini-footer-legal">

        <button
          type="button"
          class="mini-footer-link"
          @click="goToPrivacy"
        >
          Политика конфиденциальности
        </button>

        <span class="mini-footer-divider"></span>

        <button
          type="button"
          class="mini-footer-link"
          @click="goToTerms"
        >
          Условия использования
        </button>

      </div>


      <!-- ============================= -->
      <!--       🎨 RIGHT CONTROLS        -->
      <!-- ============================= -->
      <div class="footer-actions">

        <!-- THEME -->
        <button
          type="button"
          class="theme-toggle-container"
          :aria-label="
            theme === 'dark'
              ? 'Включить светлую тему'
              : 'Включить тёмную тему'
          "
          @click="toggleTheme"
        >
          <div class="toggle-track">

            <div
              class="toggle-thumb"
              :class="{
                light: theme === 'light'
              }"
            ></div>

          </div>
        </button>


        <!-- APP STORE -->
        <div class="app-download">

          <a
            href="https://apps.apple.com/ru/app/hyper/id1472576770"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Скачать приложение в App Store"
          >
            <img
              src="/appstore_icon.png"
              alt="App Store"
              class="app-icon"
            />
          </a>

        </div>

      </div>

    </div>

  </footer>
</template>


<script setup>

import { ref } from "vue";
import { useRouter } from "vue-router";


const router = useRouter();


// =============================
//          🎨 THEME
// =============================

const theme = ref(
  document.documentElement.getAttribute("data-theme")
  || localStorage.getItem("theme")
  || "light"
);


const toggleTheme = () => {

  const newTheme =
    theme.value === "dark"
      ? "light"
      : "dark";

  theme.value = newTheme;

  document.documentElement.setAttribute(
    "data-theme",
    newTheme
  );

  localStorage.setItem(
    "theme",
    newTheme
  );
};


// =============================
//        ⚖️ LEGAL PAGES
// =============================

const goToPrivacy = () => {
  router.push("/privacy-policy");
};


const goToTerms = () => {
  router.push("/terms-of-use");
};

</script>


<style scoped>

/* ============================= */
/*          🧱 FOOTER            */
/* ============================= */

.mini-footer {
  width: 100%;

  border-top:
    1px solid
    color-mix(
      in srgb,
      var(--text) 7%,
      transparent
    );

  background:
    color-mix(
      in srgb,
      var(--footer-bg, #ffffff) 97%,
      var(--primary-color, #2277e6) 3%
    );

  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);

  box-sizing: border-box;
}


/* ============================= */
/*       📦 MAIN CONTAINER       */
/* ============================= */

.footer-content {
  position: relative;

  width: 1200px;
  max-width: calc(100% - 40px);

  height: 72px;

  margin: 0 auto;

  display: flex;
  align-items: center;
  justify-content: space-between;

  box-sizing: border-box;
}


/* ============================= */
/*        🌐 SOCIAL MEDIA        */
/* ============================= */

.social-media {
  display: flex;
  align-items: center;

  gap: 12px;

  min-width: 220px;
}


.social-text {
  font-family: "Eastman-Regular", sans-serif;

  font-size: 11px;

  white-space: nowrap;

  color:
    color-mix(
      in srgb,
      var(--text, #111827) 48%,
      transparent
    );
}


.social-icons {
  display: flex;
  align-items: center;

  gap: 7px;
}


.social-link {
  width: 34px;
  height: 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;

  background:
    color-mix(
      in srgb,
      var(--text, #111827) 4%,
      transparent
    );

  transition:
    transform 0.2s ease,
    background-color 0.2s ease;
}


.social-link:hover {
  transform: translateY(-2px);

  background:
    color-mix(
      in srgb,
      #2277e6 10%,
      transparent
    );
}


.social-icon {
  width: 19px;
  height: 19px;

  display: block;

  object-fit: contain;
}


/* ============================= */
/*        ⚖️ LEGAL LINKS         */
/* ============================= */

.mini-footer-legal {
  position: absolute;

  left: 50%;
  top: 50%;

  transform:
    translate(-50%, -50%);

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 11px;

  white-space: nowrap;
}


.mini-footer-link {
  position: relative;

  padding: 3px 0;

  border: 0;

  background: transparent;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 10.5px;

  line-height: 1.3;

  color:
    color-mix(
      in srgb,
      var(--text, #111827) 48%,
      transparent
    );

  cursor: pointer;

  transition:
    color 0.2s ease;
}


.mini-footer-link:hover {
  color: #2277e6;
}


/* маленькая точка между ссылками */

.mini-footer-divider {
  width: 3px;
  height: 3px;

  flex-shrink: 0;

  border-radius: 50%;

  background:
    color-mix(
      in srgb,
      var(--text, #111827) 22%,
      transparent
    );
}


/* ============================= */
/*        🎨 RIGHT SIDE          */
/* ============================= */

.footer-actions {
  min-width: 220px;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  gap: 14px;
}


/* ============================= */
/*        🌗 THEME TOGGLE        */
/* ============================= */

.theme-toggle-container {
  padding: 0;

  border: 0;

  background: transparent;

  cursor: pointer;
}


.toggle-track {
  position: relative;

  width: 42px;
  height: 24px;

  border-radius: 999px;

  background:
    color-mix(
      in srgb,
      var(--text, #111827) 10%,
      transparent
    );

  transition:
    background-color 0.25s ease;
}


.toggle-thumb {
  position: absolute;

  top: 3px;
  left: 21px;

  width: 18px;
  height: 18px;

  border-radius: 50%;

  background: #2277e6;

  box-shadow:
    0 2px 7px
    rgba(0, 0, 0, 0.15);

  transition:
    left 0.28s
    cubic-bezier(
      0.22,
      1,
      0.36,
      1
    ),
    background-color 0.25s ease;
}


.toggle-thumb.light {
  left: 3px;

  background: #ffffff;
}


/* ============================= */
/*          🍎 APP STORE         */
/* ============================= */

.app-download {
  display: flex;
  align-items: center;
}


.app-download a {
  display: block;

  border-radius: 7px;

  transition:
    transform 0.2s ease,
    opacity 0.2s ease;
}


.app-download a:hover {
  transform: translateY(-1px);
}


.app-download a:active {
  transform: scale(0.97);
}


.app-icon {
  width: 98px;
  height: auto;

  display: block;
}


/* ============================= */
/*       🌙 DARK THEME MODE      */
/* ============================= */

[data-theme="dark"] .mini-footer {
  background: rgba(25, 25, 25, 0.07);
  border-top-color:
    rgba(85, 85, 85, 0.07);
}


[data-theme="dark"] .social-text,
[data-theme="dark"] .mini-footer-link {
  color:
    rgba(230, 230, 230, 0.52);
}


[data-theme="dark"]
.mini-footer-link:hover {
  color: #4c9aff;
}


[data-theme="dark"]
.mini-footer-divider {
  background:
    rgba(230, 230, 230, 0.25);
}


[data-theme="dark"]
.social-link {
  background:
    rgba(255, 255, 255, 0.055);
}


[data-theme="dark"]
.toggle-track {
  background:
    rgba(255, 255, 255, 0.12);
}


/* ============================= */
/*          💻 LAPTOP            */
/* ============================= */

@media (max-width: 1050px) {

  .footer-content {
    max-width:
      calc(100% - 28px);
  }


  .social-text {
    display: none;
  }


  .social-media {
    min-width: 120px;
  }


  .footer-actions {
    min-width: 180px;
  }


  .mini-footer-link {
    font-size: 10px;
  }

}


/* ============================= */
/*          📱 MOBILE            */
/* ============================= */

@media (max-width: 768px) {

  .footer-content {
    width: 100%;
    max-width: 100%;

    height: auto;

    min-height: 74px;

    padding:
      12px
      14px;

    display: grid;

    grid-template-columns:
      auto
      1fr
      auto;

    gap: 12px;
  }


  .social-media {
    min-width: 0;
  }


  .footer-actions {
    min-width: 0;

    gap: 9px;
  }


  /*
   * На мобильном legal уже не absolute,
   * иначе ссылки могут налезать на кнопки.
   */
  .mini-footer-legal {
    position: static;

    transform: none;

    grid-column:
      1 / -1;

    grid-row: 2;

    width: 100%;

    justify-content: center;

    margin-top: 2px;
  }


  .app-icon {
    width: 90px;
  }

}


/* ============================= */
/*        📱 SMALL MOBILE        */
/* ============================= */

@media (max-width: 430px) {

  .footer-content {
    padding:
      10px
      12px;
  }


  .social-link {
    width: 31px;
    height: 31px;
  }


  .social-icon {
    width: 18px;
    height: 18px;
  }


  .app-icon {
    width: 84px;
  }


  .toggle-track {
    width: 38px;
    height: 22px;
  }


  .toggle-thumb {
    width: 16px;
    height: 16px;

    top: 3px;
    left: 19px;
  }


  .toggle-thumb.light {
    left: 3px;
  }


  .mini-footer-legal {
    gap: 8px;
  }


  .mini-footer-link {
    font-size: 9px;
  }

}

</style>